<template>
  <div class="page">
    <el-card shadow="never">
      <div slot="header" class="card-header">
        <span>角色管理</span>
        <el-button type="primary" size="small" @click="openDialog()">新增角色</el-button>
      </div>
      <el-table v-loading="loading" :data="list" border stripe>
        <el-table-column prop="id" label="ID" width="70" />
        <el-table-column prop="roleCode" label="角色编码" min-width="120" />
        <el-table-column prop="roleName" label="角色名称" min-width="120" />
        <el-table-column label="菜单数" width="90" align="center">
          <template slot-scope="{ row }">{{ (row.menuIds || []).length }}</template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="140" show-overflow-tooltip />
        <el-table-column prop="status" label="状态" width="90">
          <template slot-scope="{ row }">{{ labelOf(COMMON_STATUS, row.status) }}</template>
        </el-table-column>
        <el-table-column prop="sortOrder" label="排序" width="80" />
        <el-table-column label="操作" width="180" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="openDialog(row)">编辑</el-button>
            <el-button type="text" size="small" class="danger" @click="handleDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog
      :title="form.id ? '编辑角色' : '新增角色'"
      :visible.sync="visible"
      width="640px"
      top="6vh"
      @opened="handleDialogOpened"
      @closed="handleDialogClosed"
    >
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-form-item label="编码" prop="roleCode">
          <el-input v-model="form.roleCode" />
        </el-form-item>
        <el-form-item label="名称" prop="roleName">
          <el-input v-model="form.roleName" />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="form.remark" />
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.sortOrder" :min="0" />
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="form.status" style="width: 100%">
            <el-option v-for="opt in statusOptions" :key="opt.value" :label="opt.label" :value="opt.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="菜单权限">
          <div v-loading="menuLoading" class="menu-tree-wrap">
            <el-tree
              v-if="menuTree.length"
              ref="menuTree"
              :data="menuTree"
              show-checkbox
              node-key="id"
              default-expand-all
              :props="{ label: 'menuName', children: 'children' }"
            />
            <div v-else class="menu-empty">暂无菜单数据</div>
          </div>
          <div class="menu-tip">勾选该角色可访问的后台菜单，保存后相关管理员需重新登录生效。</div>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" :loading="submitting" @click="submit">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getRoles, saveRole, deleteRole, getSystemMenus } from '@/api/admin'
import { COMMON_STATUS, labelOf, optionsOf } from '@/utils/adminConstants'
import { buildMenuTree } from '@/utils/menuTree'

export default {
  name: 'SystemRoles',
  data() {
    return {
      COMMON_STATUS,
      loading: false,
      menuLoading: false,
      list: [],
      menuList: [],
      visible: false,
      submitting: false,
      pendingMenuIds: [],
      form: {
        id: null,
        roleCode: '',
        roleName: '',
        remark: '',
        sortOrder: 0,
        status: 1,
        menuIds: []
      },
      rules: {
        roleCode: [{ required: true, message: '请输入角色编码', trigger: 'blur' }],
        roleName: [{ required: true, message: '请输入角色名称', trigger: 'blur' }]
      }
    }
  },
  computed: {
    statusOptions() {
      return optionsOf(COMMON_STATUS)
    },
    menuTree() {
      return buildMenuTree(this.menuList.filter(item => item.status === 1))
    }
  },
  created() {
    this.loadRoles()
    this.loadMenus()
  },
  methods: {
    labelOf,
    async loadRoles() {
      this.loading = true
      try {
        this.list = await getRoles() || []
      } catch (e) {
      } finally {
        this.loading = false
      }
    },
    async loadMenus() {
      this.menuLoading = true
      try {
        this.menuList = await getSystemMenus() || []
      } catch (e) {
      } finally {
        this.menuLoading = false
      }
    },
    openDialog(row) {
      if (row) {
        this.form = {
          id: row.id,
          roleCode: row.roleCode,
          roleName: row.roleName,
          remark: row.remark || '',
          sortOrder: row.sortOrder || 0,
          status: row.status,
          menuIds: [...(row.menuIds || [])]
        }
        this.pendingMenuIds = [...(row.menuIds || [])]
      } else {
        this.form = {
          id: null,
          roleCode: '',
          roleName: '',
          remark: '',
          sortOrder: 0,
          status: 1,
          menuIds: []
        }
        this.pendingMenuIds = []
      }
      this.visible = true
    },
    handleDialogOpened() {
      this.$nextTick(() => {
        if (!this.$refs.menuTree) return
        this.$refs.menuTree.setCheckedKeys(this.pendingMenuIds)
      })
    },
    handleDialogClosed() {
      this.pendingMenuIds = []
    },
    collectMenuIds() {
      if (!this.$refs.menuTree) return []
      const checked = this.$refs.menuTree.getCheckedKeys()
      const half = this.$refs.menuTree.getHalfCheckedKeys()
      return [...new Set([...checked, ...half])]
    },
    submit() {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        this.submitting = true
        try {
          await saveRole({
            ...this.form,
            menuIds: this.collectMenuIds()
          })
          this.$message.success('保存成功')
          this.visible = false
          this.loadRoles()
        } catch (e) {
        } finally {
          this.submitting = false
        }
      })
    },
    handleDelete(row) {
      this.$confirm('确定删除该角色？', '提示', { type: 'warning' }).then(async () => {
        try {
          await deleteRole(row.id)
          this.$message.success('已删除')
          this.loadRoles()
        } catch (e) {
        }
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.danger {
  color: #f56c6c;
}
.menu-tree-wrap {
  max-height: 280px;
  overflow: auto;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 8px 12px;
}
.menu-empty {
  color: #909399;
  font-size: 13px;
  padding: 12px 0;
  text-align: center;
}
.menu-tip {
  margin-top: 8px;
  font-size: 12px;
  color: #909399;
  line-height: 1.5;
}
</style>
